// @flow

import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontCondensed } from "@fdr/static-ui/Typography";

export const RaceResultsHeaderContainer = styled.li`
  background-color: ${buildColor("grey", "100")};
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  ${({ hasTopBorder }) =>
    hasTopBorder &&
    css`
      border-top: 1px solid ${buildColor("grey", "300")};
    `};
`;

export const LeftWrapper = styled.ul`
  margin: 8px 0 8px 16px;
  display: flex;
  list-style: none;

  & > li {
    letter-spacing: 1px;
  }
`;

export const RightWrapper = styled.ul`
  display: flex;
  justify-content: flex-end;
  flex: 1;
  list-style: none;
  margin: 8px 16px 8px 0;
  & > li {
    letter-spacing: 1px;
  }
`;

const textStyle = css`
  font-size: 10px;
  font-family: ${fontCondensed};
  text-transform: uppercase;
  color: ${buildColor("grey", "800")};
`;

export const Position = styled.li`
  ${textStyle};
  width: 24px;
  font-size: 12px;
  text-align: left;
`;

export const Number = styled.li`
  ${textStyle};
  width: 40px;
  text-align: center;
`;

export const Runner = styled.li`
  ${textStyle};
  text-align: left;

  &:last-child {
    margin-left: 8px;
  }
`;

export const WagerType = styled.li`
  ${textStyle};
  text-align: right;
  width: 51px;
  margin-right: 12px;

  &:first-child {
    margin-right: 16px;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const OddsTitle = styled.li`
  ${textStyle};
  font-size: 12px;
  text-align: right;
`;
